export default "__VITE_ASSET__CZu531Vl__"